/**
 * Book entity, used for filtering as well.
 */
export class packageLookup {
    code: any;    
    length: any;
    width: any;
    height: any;
    weight: any;
  }